import { Button, Input } from "@elaniintc/goes-design-system";
import type { RegistryInputMode } from "../types";
import type { NodeVariable } from "../../types";
import type { Variable } from "../../if/types";
import { VariableSelector } from "../../if/VariableSelector";
import { cn } from "@/utils/theme";

export interface RegistryIdInputProps {
  mode: RegistryInputMode;
  onModeChange: (mode: RegistryInputMode) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  selectedVariable: Variable | null;
  onVariableChange: (variable: Variable | null) => void;
  variables: NodeVariable[];
  disabled?: boolean;
  placeholder?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const RegistryIdInput = ({
  mode,
  onModeChange,
  inputValue,
  onInputChange,
  selectedVariable,
  onVariableChange,
  variables,
  disabled,
  placeholder = "Escribe el ID de un registro",
  open,
  onOpenChange,
}: RegistryIdInputProps) => {
  const toggleMode = () => {
    const newMode = mode === "inp" ? "var" : "inp";
    onModeChange(newMode);
    // Clear the other mode's value when switching
    if (newMode === "inp") {
      onVariableChange(null);
    } else {
      onInputChange("");
    }
  };

  return (
    <>
      <Button
        variant="quiet"
        group="left"
        disabled={disabled}
        onClick={toggleMode}
        className="min-w-12 font-semibold h-full"
      >
        {mode}
      </Button>
      {mode === "inp" ? (
        <div
          className={cn(
            "relative flex-1 -ml-px",
            disabled && "opacity-50 pointer-events-none",
          )}
        >
          <Input
            group="middle"
            className="w-full border-t border-b border-neutral"
            placeholder={placeholder}
            value={inputValue}
            disabled={disabled}
            onChange={(e) => onInputChange(e.target.value)}
          />
        </div>
      ) : (
        <VariableSelector
          variables={variables}
          selectedVariable={selectedVariable}
          onSelectVariable={(variable) => {
            onVariableChange(variable);
          }}
          placeholder="Selecciona una variable"
          triggerGroup="middle"
          className={cn(
            "flex-1 border-t border-b border-neutral -ml-px",
            disabled && "opacity-50 cursor-not-allowed",
          )}
          isLoading={disabled}
          open={open}
          onOpenChange={onOpenChange}
        />
      )}
    </>
  );
};
